import request from '../utils/request'

/*
    获取验证码  
*/
export function RequestPhoneCode(phone) {
    return request({
        url: '/admin/RequestPhoneCode',
        method: 'POST',
        data: { phone },
        noAuth: true,
    })
}

/*
    手机号验证码登录
*/
export function PhoneNumberLoginOrRegiste(data) {
    return request({
        url: '/admin/PhoneNumberLoginOrRegiste',
        method: 'POST',
        data: { 
            userDeviceInfo: window.navigator.userAgent,
            ...data
        },
        noAuth: true,
    })
}


/*
    获取忘记密码短信验证码  -- 暂时用不到，用上面的RequestPhoneCode代替
*/
export function RequestForgetPasswdCode(phone) {
    return request({
        url: '/admin/RequestForgetPasswdCode',
        method: 'POST',
        data: { phone },
        noAuth: true,
    })
}

/*
    忘记密码接口
*/
export function RequestForgetPassWd(data) {
    return request({
        url: '/admin/RequestForgetPassWd',
        method: 'POST',
        data,
        noAuth: true,
        loading: true,
        loadingText: '正在提交...'
    })
}

/*
    登录进入首页 -> 检测到未设置密码 ? 设置密码 : 不设置
    设置密码接口
*/
export function RequestRegistUser(data) {
    return request({
        url: '/admin/RequestRegistUser',
        method: 'POST',
        data,
        loading: true,
        loadingText: '正在提交...'
    })
}


/*
    用户账号密码登录
*/
export function RequestAccountPasswdLogin(data) {
    return request({
        url: '/admin/RequestAccountPasswdLogin',
        method: 'POST',
        data,
        noAuth: true,
    })
}

/*
    个人中心修改密码
*/
export function RequestUpdatePassWd(data) {
    return request({
        url: '/admin/RequestUpdatePassWd',
        method: 'POST',
        data,
        loading: true,
        loadingText: '正在提交...'
    })
}

/*
    用户退出登录
*/
export function userSignOut(data) {
    return request({
        url: '/admin/userSignOut',
        method: 'POST',
        data,
        noAuth: true,
    })
}


/*
    数字货仓根据配置项获取值
    @params
    {
        "configName": ""
    }
*/
export function getConfigKey(data) {
    return request({
        url: '/config/getConfigKey',
        method: 'POST',
        data
    })
}

/*
    供应商-销售商 切换身份
    @params
    {
        "userId": "5403", "userInitialType":"1"
    }
*/
export function changeType(data) {
    return request({
        url: '/admin/changeType',
        method: 'POST',
        data
    })
}

/*
    获取源数据
    @params
    {
        "types":"10201,10232,11101,11102"
    }
*/
export function getDatasource(data) {
    return request({
        url: '/yijiajiaDataCategory/getDatasource',
        method: 'POST',
        data
    })
}

/*
    获取款式分类
    @params
    {
        "parentId":"0"
    }
*/
export function categoryInfo(data) {
    return request({
        url: '/yijiajiaDataCategory/categoryInfo',
        method: 'POST',
        data
    })
}

/*
    通用多图上传接口
    @params
        files：fjjfkfk1377.jpg,73884jdjd.jpg(可一张或者多张一起上传)
        imageType：11101
        imageUserId:442

    form-data类型
        12101 商品图片
        12201 订单付款图片
        12301 订单结款凭证
*/
export const uploadFileApi = process.env.VUE_APP_BASE_API + '/file/uploadfilebatch'


/*
    个人中心-我的基础资料
*/
export function userInfo(data) {
    return request({
        url: '/admin/userInfo',
        method: 'POST',
        data
    })
}
